import React from 'react';
import logo from '../../assets/logo.jpg';
import './Hero.css';

export default function Hero({ onOpenFacture }) {
  return (
    <section className="hero" id="accueil">
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-content">
        <img src={logo} alt="Logo KOTOSTECHNOLOGY" className="hero-logo" />
        <div className="hero-badge">
          <span className="blink">◉</span>&nbsp;Bénin · Excellence &amp; Innovation
        </div>
        <h1 className="hero-title">
          <span>KOTOSTECHNOLOGY</span><br />
          {/* Le &nbsp; entre "Partenaire" et "Technologique" a été retiré :
              il collait les deux mots en un bloc insécable qui, à certaines
              largeurs d'écran, ne rentrait plus sur la ligne. Le navigateur
              coupait alors le mot en plein milieu au lieu de le renvoyer
              proprement à la ligne suivante (d'où le "e" isolé observé). */}
          <span className="tc-blue">Votre Partenaire</span>{' '}
          <span className="tc-gold">Technologique</span>
        </h1>
        <p className="hero-desc">
          Solutions numériques, solaires, immobilières et de forage sur mesure
          au Bénin et en Afrique. Excellence – Innovation – Performance.
        </p>
        <p className="hero-rccm">
          RCCM N° 2011/A/016 · JEHOVA-JIRE MULTI-SERVICES (J.J.M.S) ·
          IFU: 1201200109402 · www.kotostechnology.com
        </p>
        <div className="hero-btns">
          <a href="#services"   className="btn btn-blue">Nos Services ↓</a>
          <a href="#formations" className="btn btn-gold">Formations Certifiantes</a>
          <button className="btn btn-green" onClick={onOpenFacture}>🧾 Générer une Facture</button>
          <a href="#contact"    className="btn btn-outline">Devis gratuit</a>
        </div>
        <div className="hero-stats">
          {[['6+','Domaines'],['100%','Sur mesure'],['24/7','Support'],['2011','Création']].map(([n,l]) => (
            <div key={l} className="stat">
              <div className="stat-num">{n}</div>
              <div className="stat-label">{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}